// extracted by mini-css-extract-plugin
export var alignLeft = "y_qh d_fp d_bG d_dv";
export var alignCenter = "y_bP d_fq d_bD d_dw";
export var alignRight = "y_qj d_fr d_bH d_dx";
export var container = "y_mw d_dW d_Z";
export var containerFull = "y_sm d_dT d_Z";
export var images = "y_sn";
export var image = "y_sp d_w d_H d_bd d_0 d_8 d_7 d_4 d_9 d_dy";
export var imageWrapper = "y_qB";
export var design1 = "y_sq";